import { h, render } from 'preact';
import InviteManager from './InviteManager';

render(<InviteManager />, document.getElementById('invitationApp'));
